class DaysServices {
  static getDayStart = (date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);

  static getDayEnd = (date) =>
    new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      59,
      999
    );

  static setDateTime = (date, time) => {
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

    const result = new Date(date);
    if (timeRegex.test(time)) {
      const [hours, minutes, seconds] = time.split(":").map(Number);
      result.setHours(hours, minutes, seconds, 0);
    } else {
      result.setHours(0, 0, 0, 0);
    }

    return result;
  };
}

export default DaysServices;
